"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _mixinPanel = _interopRequireDefault(require("@/libs/flowable/common/mixinPanel"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  mixins: [_mixinPanel.default],
  data: function data() {
    return {
      dialogVisible: true,
      formData: {
        signal: []
      }
    };
  },
  computed: {
    formConfig: function formConfig() {
      //   const _this = this
      return {
        inline: false,
        item: [{
          xType: 'tabs',
          tabs: [{
            label: '信号定义',
            name: 'signal',
            column: [{
              label: 'scope',
              name: 'scope',
              width: 180,
              rules: [{
                required: true,
                message: '请选择',
                trigger: ['blur', 'change']
              }],
              xType: 'select',
              dic: [{
                label: '全局',
                value: 'start'
              }, {
                label: '流程实例',
                value: 'end'
              }]
            }, {
              label: 'id',
              name: 'id',
              width: 200,
              rules: [{
                required: true,
                message: '请输入',
                trigger: ['blur', 'change']
              }],
              xType: 'input'
            }, {
              label: '名称',
              name: 'name',
              xType: 'input',
              rules: [{
                required: true,
                message: '请输入',
                trigger: ['blur', 'change']
              }]
            }]
          }]
        }]
      };
    }
  },
  mounted: function mounted() {
    // this.formData.signal = this.element.businessObject.extensionElements.values.map(item => {
    //   let type
    //   if ('class' in item.$attrs) type = 'class'
    //   if ('expression' in item.$attrs) type = 'expression'
    //   if ('delegateExpression' in item.$attrs) type = 'delegateExpression'
    //   return {
    //     event: item.$attrs.event,
    //     type: type,
    //     className: item.$attrs[type]
    //   }
    // }) ?? []
  },
  methods: {
    updateElement: function updateElement() {
      if (this.formData.signal.length) {
        var extensionElements = this.element.businessObject.get('extensionElements');
        if (!extensionElements) {
          extensionElements = this.modeler.get('moddle').create('bpmn:signal');
        }
        var length = extensionElements.get('values').length;
        for (var i = 0; i < length; i++) {
          // 清除旧值
          extensionElements.get('values').pop();
        }
        this.updateProperties({
          extensionElements: extensionElements
        });
      } else {
        var _extensionElements = this.element.businessObject["extensionElements"];
        if (_extensionElements) {
          _extensionElements.values = _extensionElements.values.filter(function (item) {
            return item.$type !== 'flowable:ExecutionListener';
          });
        }
      }
    },
    closeDialog: function closeDialog() {
      var _this = this;
      this.$refs.xForm.validate().then(function () {
        _this.updateElement();
        _this.dialogVisible = false;
      }).catch(function (e) {
        return console.error(e);
      });
    }
  }
};